<div class="controls-container">
  <p class="controls-title" i18n>Show only the following columns in the table:</p>

    <mat-form-field appearance="outline" class="search">
      <input matInput [(ngModel)]="searchText" placeholder="Start typing to find a column" aria-label="Search column by name" i18n-placeholder i18n-label/>
      <button *ngIf="searchText" matSuffix mat-icon-button aria-label="Clear search" (click)="searchText=''">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <ng-template #columnTemplate let-columns="columns">
      <div *ngFor="let column of columns | labelFilter:searchText">
        <mat-checkbox [checked]="isSelected(column.id)" (change)="onSelected(column.id)">
          <span *ngIf="searchText">{{ column.group }}: </span>{{ column.label }}
        </mat-checkbox>
      </div>
    </ng-template>

    <div class="checkbox-columns" *ngIf="groupCount <= 1 || (searchText && searchText?.length > 0)">
      <ng-container *ngTemplateOutlet="columnTemplate; context: { columns: allAvailable }"></ng-container>
    </div>

    <mat-accordion *ngIf="groupCount > 1 && (!searchText || searchText?.length === 0)">
      <mat-expansion-panel *ngFor="let group of allAvailableGrouped | keyvalue; let index = index;">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{group.key}}
          </mat-panel-title>
          <mat-panel-description i18n>
            {{ countSelectedColumns(group.value) }} out of {{group.value.length}} columns selected
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="checkbox-columns">
          <ng-container *ngTemplateOutlet="columnTemplate; context: { columns: group.value }"></ng-container>
        </div>
        <button class="button--plain" (click)="selectAllInGroup(group.value)" i18n>Select all</button>
        <span> / </span>
        <button class="button--plain" (click)="deselectAllInGroup(group.value)" i18n>Deselect all</button>
      </mat-expansion-panel>
    </mat-accordion>

    <div class="controls-footer-buttons">
      <button mat-flat-button (click)="onResetToDefault()" i18n>Reset to default</button>
    </div>
</div>
